import { render, staticRenderFns } from "./GooglePlayReplyReview.vue?vue&type=template&id=64dc7bbc&scoped=true"
import script from "./GooglePlayReplyReview.vue?vue&type=script&lang=js"
export * from "./GooglePlayReplyReview.vue?vue&type=script&lang=js"
import style0 from "./GooglePlayReplyReview.vue?vue&type=style&index=0&id=64dc7bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc7bbc",
  null
  
)

export default component.exports